var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIconRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "14px",
    height: "16px",
    viewBox: "0 0 14 16",
    enableBackground: "new 0 0 14 16",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_237_",
    fill: "#ee0013",
    d: "M1.604,6.005v8.016c0,0.884,0.718,1.604,1.603,1.604h7.48c0.884,0,1.604-0.72,1.604-1.604 V6.005H1.604z M4.809,12.952c0,0.295-0.239,0.534-0.535,0.534c-0.294,0-0.534-0.239-0.534-0.534V8.144 c0-0.295,0.24-0.535,0.534-0.535c0.295,0,0.535,0.239,0.535,0.535V12.952z M7.48,12.952c0,0.295-0.239,0.534-0.534,0.534 s-0.535-0.239-0.535-0.534V8.144c0-0.295,0.24-0.535,0.535-0.535S7.48,7.848,7.48,8.144V12.952z M10.152,12.952 c0,0.295-0.239,0.534-0.534,0.534s-0.534-0.239-0.534-0.534V8.144c0-0.295,0.239-0.535,0.534-0.535s0.534,0.239,0.534,0.535V12.952 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_243_",
    fill: "#ee0013",
    d: "M12.824,2.8H9.618V2.266c0-0.884-0.718-1.604-1.604-1.604H5.878 c-0.884,0-1.604,0.72-1.604,1.604V2.8H1.069C0.479,2.8,0,3.279,0,3.869v0.534c0,0.295,0.239,0.534,0.535,0.534h12.825 c0.295,0,0.534-0.239,0.534-0.534V3.869C13.894,3.279,13.415,2.8,12.824,2.8z M5.343,2.266c0-0.294,0.24-0.535,0.535-0.535h2.137 c0.295,0,0.534,0.24,0.534,0.535V2.8H5.343V2.266z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIconRed);
export default __webpack_public_path__ + "static/media/delete-icon-red.35f221de0520f0112148fb4aa5fb462e.svg";
export { ForwardRef as ReactComponent };